"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartnerCopy = exports.VerticalLine = exports.PartnerCopyWrapper = exports.PartnerLogo = exports.PartnerLogoWrapper = exports.PartnerInfo = exports.PartnerInner = exports.PartnerWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PartnerWrapper = _styledComponents.default.div.attrs({
  "data-qa": "partner-wrapper"
}).withConfig({
  displayName: "Partnerstyles__PartnerWrapper",
  componentId: "mv4iy7-0"
})(["height:37px;left:0;position:absolute;top:0;@media (min-width:", "px){height:40px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.PartnerWrapper = PartnerWrapper;

var PartnerInner = _styledComponents.default.div.attrs({
  "data-qa": "partner-inner"
}).withConfig({
  displayName: "Partnerstyles__PartnerInner",
  componentId: "mv4iy7-1"
})(["background-color:", ";border-radius:0 15px 0px 0px;display:inline-block;height:100%;max-width:206px;position:relative;z-index:2;&:before{height:37px;width:32px;border-radius:0px 6px 0px 0px;background-color:", ";content:'';position:absolute;right:-16px;top:0px;-webkit-transform:skewX(40deg);transform:skewX(40deg);z-index:-1;@media (min-width:", "px){border-radius:0px 10px 0px 0px;height:40px;right:-19px;width:40px;}}&:after{height:36px;width:10px;border-radius:0 0 0 6px;background-color:", ";content:'';position:absolute;right:-24px;bottom:1px;-webkit-transform:skewX(40deg);transform:skewX(40deg);z-index:-1;@media (min-width:", "px){bottom:0px;height:40px;width:40px;}}@media (min-width:", "px){max-width:334px;}"], function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return props.theme.carvana.white.primary;
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.theme.carvana.blue.medium;
}, function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.PartnerInner = PartnerInner;

var PartnerInfo = _styledComponents.default.div.attrs({
  "data-qa": "partner-info"
}).withConfig({
  displayName: "Partnerstyles__PartnerInfo",
  componentId: "mv4iy7-2"
})(["align-items:flex-end;display:inline-flex;height:100%;padding:0 16px;width:100%;@media (min-width:", "px){padding:0 33px 0;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.PartnerInfo = PartnerInfo;

var PartnerLogoWrapper = _styledComponents.default.div.attrs({
  "data-qa": "partner-logo-wrapper"
}).withConfig({
  displayName: "Partnerstyles__PartnerLogoWrapper",
  componentId: "mv4iy7-3"
})(["height:100%;padding-top:4px;@media (min-width:", "px){padding-top:8px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.PartnerLogoWrapper = PartnerLogoWrapper;

var PartnerLogo = _styledComponents.default.img.attrs({
  "data-qa": "partner-logo"
}).withConfig({
  displayName: "Partnerstyles__PartnerLogo",
  componentId: "mv4iy7-4"
})(["height:100%;width:auto;@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){height:100%;max-height:29px;width:100%;}@media all and (min-width:", "px) and (-ms-high-contrast:none),(-ms-high-contrast:active){max-height:40px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.PartnerLogo = PartnerLogo;

var PartnerCopyWrapper = _styledComponents.default.div.attrs({
  "data-qa": "partner-copy-wrapper"
}).withConfig({
  displayName: "Partnerstyles__PartnerCopyWrapper",
  componentId: "mv4iy7-5"
})(["display:flex;align-items:center;height:100%;margin-right:10px;margin-left:5px;"]);

exports.PartnerCopyWrapper = PartnerCopyWrapper;

var VerticalLine = _styledComponents.default.div.attrs({
  "data-qa": "vertical-line"
}).withConfig({
  displayName: "Partnerstyles__VerticalLine",
  componentId: "mv4iy7-6"
})(["border-left:1px solid ", ";height:16px;margin:1px 6px 0 10px;@media (min-width:", "px){margin:1px 6px 0 19px;}"], function (props) {
  return props.theme.carvana.gray.dark;
}, function (props) {
  return props.theme.breakpoints.values.sm;
});

exports.VerticalLine = VerticalLine;

var PartnerCopy = _styledComponents.default.div.attrs({
  "data-qa": "partner-copy"
}).withConfig({
  displayName: "Partnerstyles__PartnerCopy",
  componentId: "mv4iy7-7"
})(["color:", ";font-size:8px;font-weight:400;height:19px;letter-spacing:0.16px;line-height:10px;text-transform:uppercase;width:54px;"], function (props) {
  return props.theme.carvana.gray.dark;
});

exports.PartnerCopy = PartnerCopy;